import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { axiosNewInstance } from "../../config/Api";
import { connect } from "react-redux";
import Select from "react-select";
import LangData from "../common/LangData";

const options = [
  { value: '56984', label: '56984' },
  { value: '56964', label: '56964' },
  { value: '56684', label: '56684' },
  { value: '55654', label: '55654' },
  { value: '36984', label: '36984' },
  { value: '45698', label: '45698' },
  { value: '69875', label: '69875' },
];

const CustomerPolicyList = ({ lang }) => {
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const history = useHistory();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (token) {
      fetchDashboardData();
    } else {
      history.push("/login");
    }
  }, []);

  const fetchDashboardData = async (page = 1) => {
    const FETCH_DASHBOARD_URL = "/api-app/customer-dashboard";
    setLoading(true);
    try {
      const response = await axiosNewInstance.post(
        FETCH_DASHBOARD_URL,
        { page },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Fetched user dashboard data:", response.data.data.policies);
      setDashboardData(response?.data?.data?.policies || []);
    } catch (error) {
      console.error("Error fetching user dashboard:", error?.response || error);
      // if (error.response?.data?.status === 0) {
      //   localStorage.removeItem("authToken");
      //   history.push("/login");
      // }
    } finally {
      setLoading(false);
    }
  };

  const handleView = (policyId) => {
    history.push(`/policy-view-customer/${policyId}`);
  };

  // const handleChange = () => {};

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: 300,
  //   }),
  // };

  return (
    <div className="container mt-4">
      <div className="container mt-5">
        <div className="row g-0">
          <div className="col-md-12 pr-2">
            <div className="card p-3 shadow-sm">
            <h5 className="font-weight-bold fs-4 my-3">
              <LangData keyname="label_policy_list" />
              </h5>
              <div className="table-responsive">
                <table className="table text-left">
                  <thead>
                    <tr>
                       <th scope="col"><LangData keyname="label_serial" /></th>
                       <th scope="col"><LangData keyname="label_name" /></th>
                       <th scope="col"><LangData keyname="label_policy_id" /></th>
                       <th scope="col"><LangData keyname="label_ref_id" /></th>
                       <th scope="col"><LangData keyname="label_mobile" /></th>
                       <th scope="col"><LangData keyname="label_product_name" /></th>
                       <th scope="col"><LangData keyname="label_status" /></th>
                       <th scope="col"><LangData keyname="label_action" /></th>
                      {/* <th scope="col">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData && dashboardData.length > 0 ? (
                      dashboardData.map((item, index) => (
                        <tr key={item?.id}>
                          <td className="text-left">{index + 1}</td>
                          <td>{`${item?.customer?.first_name || ""} ${item?.customer?.last_name || ""}`}</td>
                          <td className="text-left">{item?.sap_policy_id || "N/A"}</td>
                          <td className="text-left">{item?.ref_unique_id || "N/A"}</td>
                          <td>{item?.customer?.mobile || "N/A"}</td>
                          <td className="text-left">{item?.policy?.name || "N/A"}</td>
                          <td className={item?.status === 'Paid' ? 'text-primary text-left' : 'text-danger text-left'}>
                            {item?.status || 'Due'}
                          </td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm ms-1"
                              onClick={() => handleView(item?.id)}
                            >
                              <i className="fas fa-eye"></i>
                            </button>

                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted">No Data Available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(CustomerPolicyList);